module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/chase@3x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/chase@3x.png
// module id = 1163
// module chunks = 0